import { render, staticRenderFns } from "./ViewAllLayout.vue?vue&type=template&id=9ed650b4"
import script from "./ViewAllLayout.vue?vue&type=script&lang=js"
export * from "./ViewAllLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports